import DependencyReducer from 'yoda-site-components/lib/reducers';
import AddToCartInterstitialReducer from 'yoda-checkout-components/lib/reducers/AddToCartInterstitialReducer';
import MyListNameReducer from 'yoda-account-components/lib/reducers/MyListNameReducer';
import LoadingReducer from 'yoda-site-components/lib/reducers/LoadingReducer';
import AddToCartReducer from 'yoda-site-components/lib/reducers/AddToCartReducer';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';
import MyAlertsReducer from 'yoda-site-components/lib/reducers/MyAlertsReducer';
import PdpNameSpaceReducerCreator from 'yoda-site-components/lib/reducers/PdpNameSpaceReducerCreator';
import MTLSavedLists from 'yoda-site-components/lib/reducers/SavedListToolTip';
import MyList from './MyListReducer';
import SavedList from './SavedListReducer';
import lastRemovedListItemReducer from './LastRemovedListItemReducer';

const rootReducer = {
    /**
     * To get stock alert status on mini pdp level
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     */
    miniPdpMyAlerts: PdpNameSpaceReducerCreator(MyAlertsReducer, true, 'myAlerts'),
    /**
     * To get stock alert status on list landing page level
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     */
    myAlerts: MyAlertsReducer,
    /**
     * addToCartInterstitialDetails used in:
     * yoda-checkout-components/src/analytics/CheckoutActionFilter.js
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     * src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * src/containers/Pages/TrendingList/TrendingListConnect.jsx
     */
    addToCartInterstitialDetails: AddToCartInterstitialReducer,
    /**
     * camNavMyList used in:
     * yoda-site-components/src/components/CreateMyList/CreateMyList.jsx
     */
    camNavMyList: MyListNameReducer,
    /**
     * MyList used in:
     * src/components/Lists/CreateListDropDown/CreateListDropDown.jsx
     * src/components/Lists/Move/Move.jsx
     * src/containers/Pages/Lists/ListLandingPageConnect.jsx
     */
    MyList,
    /**
     * savedList used in:
     * src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * src/containers/Pages/TrendingList/TrendingListConnect.jsx
     */
    /**
     * MTLSavedLists
     * yoda-microsite-listing/src/components/Lists/Move/Move.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     */
    MTLSavedLists,
    savedList: SavedList,
    /**
     * full screen loading
     * yoda-microsite-coupon/src/containers/Pages/Coupon/Coupon.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-homepage/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * yoda-microsite-pdp/src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-microsite-pdp/src/components/ImageZoom/ImageZoom.jsx
     * yoda-microsite-listing/src/common/CustomAddToCart/CustomAddToCart.jsx
     */
    isLoading: LoadingReducer,
    /**
     * add to cart site
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingListConnect.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-mini-pdp/src/components/MiniPDPInterstitial/MiniPDPInterstitialAsync.jsx
     * mini pdp
     */
    addToCartSite: AddToCartReducer,
    ...DependencyReducer,
    /**
     * lastRemovedListItem used in:
     * src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * src/containers/Pages/Lists/ListLandingPage.jsx
     */
    lastRemovedListItem: lastRemovedListItemReducer,
    webvitals: WebvitalsReducer,
};

export default rootReducer;
